__turbopack_context__.v({
  "panel": "tab-panel-module__a5uaYq__panel",
});
